
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class TerminalStreamsEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
        const spacing = (30 + layerIndex * 10) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2 } = this.getGridBounds(pc, spacing);
        const scale = config.parallaxScale || 1.0;
        const speed = (200 + layerIndex * 100) * config.parallaxSpeed;

        ctx.fillStyle = pc.color;
        ctx.font = `${10 * scale}px monospace`;

        const draw = () => {
            for (let x = x1; x <= x2; x += spacing) {
                const columnP = this.pseudoRandom(x);
                const scrollY = (time * speed * (0.5 + columnP)) % (height * 2);
                
                for (let i = 0; i < 20; i++) {
                    const y = -height + scrollY - i * 15 * scale;
                    if (y > -height && y < height) {
                        const alpha = 1 - (i / 20);
                        ctx.globalAlpha = alpha * 0.7;
                        // Random hex char
                        const char = Math.floor(this.pseudoRandom(x + i + Math.floor(time * 10)) * 16).toString(16).toUpperCase();
                        ctx.fillText(char, x, y);
                    }
                }
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
